export default function SurseFinanciarePage() {

  const files = [
    "Bilant.PDF",
    "BL 2026.PDF",
    "BS 2026.PDF",
    "Contract donatie.PDF",
    "Contract_IT.PDF",
    "Inventar_buget de stat.PDF",
    "Inventar_buget local.PDF",
    "Program anual de achizitii publice 2026.PDF",
    "Proiect BL 2026.PDF",
    "Proiect BS 2026.PDF",
    "Raportare lunara.PDF",
    "Rectificare bugetara_BL.PDF",
    "Rectificare bugetara_BS.PDF",
  ];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/documente/surseFinanciare/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
               {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}